import {useCallback} from 'react';

import {RolesAccount} from '@/app/auth';
import {CARDS_THEME_API_EVENTS} from '@/app/auth/events/CardsThemeApiEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

import {ICardThemesV2Response} from './entities';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackApiSuccessCardThemeListRetrieval = useCallback(
    (themeList: string[] | ICardThemesV2Response[], parentId: string) => {
      trackEvent(CARDS_THEME_API_EVENTS.API_SUCCESS_CARD_THEME_LIST_RETRIEVAL, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        Banking: {
          card: {
            theme: {
              list: themeList,
            },
          },
        },
        user: {
          id: parentId,
          role: RolesAccount.PARENT,
        },
      });
    },
    [trackEvent],
  );

  const trackApiErrorCardThemeListRetrieval = useCallback(
    (parentId: string, error: any) => {
      trackEvent(
        CARDS_THEME_API_EVENTS.API_ERROR_CARD_THEME_LIST_RETRIEVAL,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          user: {
            id: parentId,
            role: RolesAccount.PARENT,
          },
        },
        error,
      );
    },
    [trackEvent],
  );

  return {
    trackApiSuccessCardThemeListRetrieval,
    trackApiErrorCardThemeListRetrieval,
  };
};
